/** Guide engine copy (FirstUseGuide). Guide content itself lives in components/firstUseGuides.js. */
export const GUIDE_COPY = Object.freeze({
  firstVisit: 'Première visite',
  later: 'Plus tard',
  start: 'Faire le tour',
  skip: 'Passer le guide',
  skipStep: 'Passer cette étape',
  close: 'Fermer le guide',
  next: 'Suivant',
  previous: 'Précédent',
  quit: 'Quitter',
  finish: 'Terminer',
  pause: 'Pause',
  resume: 'Reprendre',
  steps: 'Étapes du guide',
  troubleshooting: 'Si cela ne fonctionne pas',
  expected: 'Résultat attendu :',
  yourTurn: 'À vous : cliquez sur la zone en surbrillance.',
  waiting: 'Néo attend que la page soit prête…',
  phase: Object.freeze({ tour: 'Visite', demo: 'Néo vous montre', you: 'À vous' }),
  progress: (n, total) => `Étape ${n} sur ${total}`,
  counter: (n, total) => `${n} / ${total}`,
  replay: (title) => `Revoir le guide : ${title}`,
  discover: (title) => `Découvrir ${title}`,
  tourLabel: (title) => `Guide ${title}`,
  hudLabel: 'Progression du guide',
  sandboxRefused: 'Exemple du guide : rien n’est enregistré.',
  downloadSimulated: 'Téléchargement simulé',
});
